module.exports = __webpack_public_path__ + "static/media/US30.5069a21e.svg";